import { useState } from 'react';
import { Button } from './ui/button';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Calendar } from './ui/calendar';
import { CalendarBlank, X } from '@phosphor-icons/react';
import { format } from 'date-fns';

export default function DateRangePicker({ dateFrom, dateTo, onChange }) {
  const [fromOpen, setFromOpen] = useState(false);
  const [toOpen, setToOpen] = useState(false);

  const handleFromSelect = (date) => {
    onChange({ dateFrom: date ? format(date, 'yyyy-MM-dd') : null, dateTo });
    setFromOpen(false);
  };

  const handleToSelect = (date) => {
    onChange({ dateFrom, dateTo: date ? format(date, 'yyyy-MM-dd') : null });
    setToOpen(false);
  };

  const handleClear = () => {
    onChange({ dateFrom: null, dateTo: null });
  };

  return (
    <div className="flex items-center gap-2" data-testid="date-range-picker">
      <Popover open={fromOpen} onOpenChange={setFromOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className="h-9 rounded-sm border-zinc-200 text-sm font-mono gap-2 px-3"
            data-testid="date-from-trigger"
          >
            <CalendarBlank size={14} />
            {dateFrom || 'From'}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            selected={dateFrom ? new Date(dateFrom + 'T00:00:00') : undefined}
            onSelect={handleFromSelect}
            initialFocus
          />
        </PopoverContent>
      </Popover>

      <span className="text-zinc-400 text-xs">to</span>

      <Popover open={toOpen} onOpenChange={setToOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className="h-9 rounded-sm border-zinc-200 text-sm font-mono gap-2 px-3"
            data-testid="date-to-trigger"
          >
            <CalendarBlank size={14} />
            {dateTo || 'To'}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            selected={dateTo ? new Date(dateTo + 'T00:00:00') : undefined}
            onSelect={handleToSelect}
            initialFocus
          />
        </PopoverContent>
      </Popover>

      {(dateFrom || dateTo) && (
        <button
          onClick={handleClear}
          className="p-1.5 text-zinc-400 hover:text-zinc-600 hover:bg-zinc-100 rounded-sm transition-colors"
          title="Clear dates"
          data-testid="date-clear-button"
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
}
